<template>
  <application-layout>
    <v-main>
      <v-container>
        <v-row>
          <v-col>
            <h1>Dashboard</h1>
          </v-col>
          <v-col align-self="end">
            <v-row justify="end" class="pb-3 mx-0">
              <v-btn
                data-testid="download-reservations-rentals-btn"
                class="download-reservations-rentals-btn"
                @click="downloadReservations"
                color="primary"
              >
                Download All Reservations &amp; Rentals
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <div v-if="!facilities.length || !totals">
          <v-row justify="center" class="pa-12">
            <v-progress-circular indeterminate color="grey" />
          </v-row>
        </div>
        <div v-else>
          <v-row align="center">
            <v-col cols="3" class="pr-2">
              <v-menu
                v-model="showStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    data-testid="index-start-date"
                    class="index-start-date"
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  v-model="startDate"
                  :min="minDate"
                  :max="currentDate"
                  @input="showStartDate = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="3" class="pl-2">
              <v-menu
                  v-model="showEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    data-testid="index-end-date"
                    class="index-end-date"
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  v-model="endDate"
                  :min="minDate"
                  :max="currentDate"
                  @input="showEndDate = false"
                />
              </v-menu>
            </v-col>
            <v-col class="pl-4 pt-2">
              <v-btn
                data-testid="filtered-stats-search-btn"
                class="filtered-stats-search-btn"
                color="primary pr-3"
                @click="getFilteredStats"
              >
                <v-icon class="mr-3">search</v-icon>
                Search
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="mb-5">
              <DashboardTotalsTable
                data-testid="reservations-website-table"
                :title="'Total Website Reservations'"
                :loading="loading"
                :source="'reservations'"
                :statistics="getStatistics('reservations')"
                :totals="totals.reservations"
              />
            </v-col>
            <v-divider class="my-3" />
            <v-col cols="6">
              <DashboardTotalsTable
                data-testid="rentals-website-table"
                :title="'Total Website Rentals'"
                :loading="loading"
                :source="'rentals'"
                :statistics="getStatistics('rentals')"
                :totals="totals.rentals"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="mb-5">
              <DashboardTotalsTable
                data-testid="reservations-call-center-table"
                :title="'Total Call Center Reservations'"
                :loading="loading"
                :source="'reservations_call_center'"
                :statistics="getStatistics('reservations_call_center')"
                :totals="totals.reservations_call_center"
              />
            </v-col>
            <v-divider class="my-3" />
            <v-col cols="6">
              <DashboardTotalsTable
                data-testid="rentals-call-center-table"
                :title="'Total Call Center Rentals'"
                :loading="loading"
                :source="'rentals_call_center'"
                :statistics="getStatistics('rentals_call_center')"
                :totals="totals.rentals_call_center"
              />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DashboardTotalsTable from "@/views/dashboard/partials/DashboardTotalsTable";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "dashboard",

  data() {
    return {
      currentDate: new Date().toISOString().substr(0, 10),
      endDate: null,
      loading: false,
      showStartDate: false,
      showEndDate: false,
      startDate: null
    };
  },

  methods: {
    downloadReservations() {
      this.$store.dispatch("downloadReservationCsv");
    },

    getFilteredStats() {
      this.loading = true;

      const payload = {
        start_date: this.startDate,
        end_date: this.endDate
      };

      this.$store.dispatch("getFilteredReservationStatistics", payload)
        .then(() => {
          this.loading = false;
        });
    },

    getStatistics(source) {
      return this.facilities.map(facility => {
        return {
          location_code: facility.location_code,
          name: facility.name,
          stats: facility[source]
        };
      });
    }
  },

  computed: {
    ...mapState({
      facilities: state => state.dashboard.facilities,
      totals: state => state.dashboard.totals
    }),

    minDate() {
      return moment().month(0).date(1).year(2016).format("YYYY-MM-DD");
    }
  },

  created() {
    this.$store.dispatch("getAllData")
      .then(() => {
        this.loading = false;
      });
  },

  components: {
    ApplicationLayout,
    DashboardTotalsTable
  }
};
</script>
